import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AddUser = () => {
  const navigate = useNavigate();
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [user, setUser] = useState({
    userName: "",
    password: "",
    isHospi: false,
    isCoordie: false,
    isAdminCooride: false,
    isSuperUser: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitDisabled(true);
    Axios.post("https://ashish.moodi.org/auth/add_compi_admin", user, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.data.status === "done") {
          window.alert("User Added Successfully");
          window.location.reload();
        }
      })
      .catch((err) => console.error(err));
  };

  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (localStorage.getItem("compiauthtoken")) {
    } else {
      navigate("/admin/login");
    }
  }, []);

  return (
    <div className="container">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <div class="input-group flex-nowrap">
            <span class="input-group-text" id="addon-wrapping">
              username
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Username"
              aria-label="Username"
              name="userName"
              aria-describedby="addon-wrapping"
              required
              onChange={onChange}
              value={user.userName}
            />
          </div>
        </div>
        <div className="mb-3">
          <div class="input-group flex-nowrap">
            <span class="input-group-text" id="addon-wrapping">
              Password
            </span>
            <input
              type="text"
              name="password"
              class="form-control"
              placeholder="Password"
              aria-label="Username"
              aria-describedby="addon-wrapping"
              onChange={onChange}
              required
              value={user.password}
            />
          </div>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="inlineCheckbox1"
            value="option1"
            checked={user.isHospi}
            onClick={() => {
              if (user.isHospi) {
                setUser({ ...user, isHospi: false });
              } else {
                setUser({ ...user, isHospi: true });
              }
            }}
          />
          <label class="form-check-label" for="inlineCheckbox1">
            isHospi
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="inlineCheckbox2"
            value="option2"
            checked={user.isCoordie}
            onClick={() => {
              if (user.isCoordie) {
                setUser({ ...user, isCoordie: false });
              } else {
                setUser({ ...user, isCoordie: true });
              }
            }}
          />
          <label class="form-check-label" for="inlineCheckbox2">
            isCoordie
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="inlineCheckbox3"
            value="option2"
            checked={user.isAdminCooride}
            onClick={() => {
              if (user.isAdminCooride) {
                setUser({ ...user, isAdminCooride: false });
              } else {
                setUser({ ...user, isAdminCooride: true });
              }
            }}
          />
          <label class="form-check-label" for="inlineCheckbox3">
            isAdminCooride
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="inlineCheckbox4"
            value="option2"
            checked={user.isSuperUser}
            onClick={() => {
              if (user.isSuperUser) {
                setUser({ ...user, isSuperUser: false });
              } else {
                setUser({ ...user, isSuperUser: true });
              }
            }}
          />
          <label class="form-check-label" for="inlineCheckbox4">
            isSuperUser
          </label>
        </div>
        <div className="row">
          {submitDisabled ? (
            <button
              class="btn btn-primary col-auto"
              type="submit"
              disabled={submitDisabled}
            >
              <span
                class="spinner-border spinner-border-sm"
                aria-hidden="true"
              ></span>
              <span role="status">Submitting...</span>
            </button>
          ) : (
            <input
              type="submit"
              value="Submit"
              className="btn btn-primary col-auto"
              disabled={submitDisabled}
            />
          )}
        </div>
      </form>
    </div>
  );
};

export default AddUser;
